module.exports = __webpack_public_path__ + "static/img/content_3.876c33f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dingding/content_3.png
// module id = L5ce
// module chunks = 94